import { createAction } from 'redux-actions';
import * as labelReviewInciWizardTypes from './labelReviewInciWizardTypes';
// import { createUpdateAction } from '../../../../utils/actions';

export const loadlabelReviewInciData = createAction(labelReviewInciWizardTypes.LOAD_LABEL_REVIEW_INCI_DATA);
export const handleCommentEdit = createAction(labelReviewInciWizardTypes.COMMENT_EDITED, (field, value) => ({
  [field]: value,
}));
